import React, { memo } from 'react';
import { LABEL } from '../../veriables';
import cn from 'classnames';
import { getObjectValue } from '@utility/utills';
import ReceiptScreen from '@components/ReceiptScreenNewUI';
import ReceiptScreenLandscapeMode from '@components/ReceiptScreenNewUI/receiptLandScape.jsx';
import { TouchableButton, TouchableDiv } from '../common/Touchable/index';
import FullWidthModal from '@components/common/Modal/FullWidthModal';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ReceiptFooter from '../ReceiptFooter';

const ItemizedCheck = ({
  serverAppTheme,
  paymentType,
  tableData,
  isTableTop,
  isKiosk,
  seat,
  // isSpeedOrderMode,
  isWalkUp,
  countryCode,
  setViewDetailsOpen,
  charity,
  serverAppThemeNumber,
  isServerApp,
  deviceInfo,
  isTogo,
  paymentLandscapeOrientation,
  ...props
}) => {
  const currenySymbol = LABEL().CURRENCY_SYMBOL;
  const authResponse = getObjectValue(
    () => JSON.parse(window.sessionStorage.getItem('authResponse')),
    null
  );

  return (
    <div>
      <FullWidthModal
        isOpen={props.viewDetailsOpen}
        noBackground
        customClass={cn('h-100')}
        customClass2="h-100 w-100"
        customWidth={true}
        style={{ backgroundColor: serverAppTheme?.popUp_bg, height: '100%' }}
      >
        <div
          className="h-100 w-100 "
          style={{ color: serverAppTheme?.primary_text }}
        >
          <div style={{ position: 'relative' }} className="h-100">
            <div
              className={cn(
                'row mx-0 flex-column w-100',
                paymentLandscapeOrientation ? 'h-7 my-1' : 'h-5'
              )}
            >
              <div
                className={cn(
                  'd-flex col-12 px-3',
                  paymentLandscapeOrientation ? 'py-1' : 'py-3'
                )}
              >
                <TouchableDiv className="d-flex col-12 px-0">
                  <div className="col-6 px-0">
                    <span className="fs_20 float-left fw-600">
                      {' '}
                      {LABEL().TABLE}{' '}
                      {seat?.stationName || seat?.name || seat?.stationNumber}
                    </span>
                  </div>
                  <div className="col-6 d-flex justify-content-end px-0">
                    <span
                      className={cn(
                        'col-6 text-right fs_20 fw-600',
                        [16, 22, 28].includes(paymentType) ? 'pr-40' : 'pr-1'
                      )}
                    >
                      #{seat?.number}
                    </span>
                  </div>
                </TouchableDiv>
              </div>
            </div>
            <div
              className={cn(
                'd-flex flex-column justify-content-between',
                paymentLandscapeOrientation ? 'h-89 px-12' : 'h-84 px-3'
              )}
            >
              {React.createElement(
                paymentLandscapeOrientation ? ReceiptScreenLandscapeMode : ReceiptScreen,
                {
                  tableData,
                  currenySymbol,
                  renderModifier: props.renderModifier,
                  renderModifierView: props.renderModifierView,
                  paymentType: props.paymentType,
                  tipAmount: props.tipAmount,
                  paymentAmount: props.paymentAmount,
                  active: props.active,
                  handleButtonClick: props.handleButtonClick,
                  handleButtonClickOtherAmount:
                    props.handleButtonClickOtherAmount,
                  charityAmount: props.charityAmount,
                  charityList: props.charityList.map(e => e.displayKey),
                  keyboardValue: props.keyboardValue,
                  handleKeyboardValue: props.handleKeyboardValue,
                  paymentFlowType: props.paymentFlowType,
                  unpaidTips: tableData?.unpaidTips,
                  paidTips: tableData?.paidTips,
                  countryCode,
                  deviceInfo: props.deviceInfo,
                  successMessage: props.successMessage,
                  charity,
                  authResponse,
                  supportsTips: props.supportsTips,
                  paymentCheck: props.paymentCheck,
                  allMenuItems: props.menuItems,
                  seat,
                  PaymentPageBtn: props.PaymentPageBtn,
                  setViewDetailsOpen,
                  viewDetailsOpen: props.viewDetailsOpen,
                  serverAppTheme,
                  isWalkUp,
                  isLandScape: paymentLandscapeOrientation,
                  isTogo,
                }
              )}
                 {!paymentLandscapeOrientation ? (
      <ReceiptFooter serverAppTheme={serverAppTheme} />
    ) : (
      <div
        className="text-center"
        style={{
          position: 'fixed',
          bottom: '14%',
          right: '12px',
          width: '430px',
          zIndex: 10,
        }}
      >
        <ReceiptFooter serverAppTheme={serverAppTheme} />
      </div>
    )}

            </div>
          </div>
        </div>     
        <div
          className={cn(
            'text-center h-5 col-12',
            paymentLandscapeOrientation
              ? ''
              : 'd-flex justify-content-center align-content-center'
          )}
        >
          <TouchableButton
            id="btnItemisd"
            className={cn(
              'position-fixed text-center align-content-center btn-ripple rounded-top44 fw-600 fs_24 od-primary-btn-bg-color od-primary-btn-font-color',
              paymentLandscapeOrientation ? 'col-6 h-11' : 'col-12 h-8 w-93'
            )}
            style={{
              borderRadius: '4px',
              bottom: '3%',
              right: paymentLandscapeOrientation ? '12px' : '',
              background: serverAppTheme?.secondaryBtn,
              color: serverAppTheme?.btn_font_color,
              width: paymentLandscapeOrientation ? '430px' : '',
            }}
            onClick={e => {
              e.preventDefault();
              setViewDetailsOpen(false);
            }}
            rippleEffect={true}
          >
            {LABEL().CLOSE}
          </TouchableButton>
        </div>
      </FullWidthModal>
    </div>
  );
}

ItemizedCheck.propTypes = {
  serverAppTheme: PropTypes.shape({
    secondaryBtn: PropTypes.string,
    btn_font_color: PropTypes.string,
    popUp_bg: PropTypes.string,
    primary_text: PropTypes.string,
  }),
  paymentType: PropTypes.string,
  tableData: PropTypes.object,
  isTableTop: PropTypes.bool,
  isKiosk: PropTypes.bool,
  seat: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isWalkUp: PropTypes.bool,
  countryCode: PropTypes.string,
  setViewDetailsOpen: PropTypes.func,
  charity: PropTypes.object,
  serverAppThemeNumber: PropTypes.number,
  isServerApp: PropTypes.bool,
  deviceInfo: PropTypes.object,
  renderModifier: PropTypes.func,
  renderModifierView: PropTypes.func,
  tipAmount: PropTypes.number,
  paymentAmount: PropTypes.number,
  active: PropTypes.bool,
  handleButtonClick: PropTypes.func,
  handleButtonClickOtherAmount: PropTypes.func,
  charityAmount: PropTypes.number,
  charityList: PropTypes.array,
  keyboardValue: PropTypes.string,
  handleKeyboardValue: PropTypes.func,
  paymentFlowType: PropTypes.string,
  successMessage: PropTypes.string,
  supportsTips: PropTypes.bool,
  paymentCheck: PropTypes.object,
  menuItems: PropTypes.array,
  PaymentPageBtn: PropTypes.elementType,
  viewDetailsOpen: PropTypes.bool,
};

ItemizedCheck.defaultProps = {
  serverAppTheme: {
    secondaryBtn: '',
    btn_font_color: '',
    popUp_bg: '',
    primary_text: '',
  },

  paymentType: '',
  tableData: {},
  isTableTop: false,
  isKiosk: false,
  seat: null,
  // isSpeedOrderMode: false,
  isWalkUp: false,
  countryCode: 'IN',
  setViewDetailsOpen: () => {},
  charity: null,
  serverAppThemeNumber: null,
  isServerApp: false,
  deviceInfo: {},
  renderModifier: () => null,
  renderModifierView: () => null,
  tipAmount: 0,
  paymentAmount: 0,
  active: false,
  handleButtonClick: () => {},
  handleButtonClickOtherAmount: () => {},
  charityAmount: 0,
  charityList: [],
  keyboardValue: '',
  handleKeyboardValue: () => {},
  paymentFlowType: '',
  successMessage: '',
  supportsTips: false,
  paymentCheck: null,
  menuItems: [],
  PaymentPageBtn: null,
  viewDetailsOpen: false,
};


const mapStateToProps = ({ payment }) => ({
  paymentLandscapeOrientation: payment.paymentLandscapeOrientation
});

const MemoizedItemizedCheck = memo(ItemizedCheck)

export default connect(mapStateToProps)(MemoizedItemizedCheck);